import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { regisActions, certificateActions } from '../../../store/actions'
import history from '../../../route/history'
import * as common from '../../../assets/js/common.js'

export const RegisUserStep3 = (props) => {
  useEffect(() => {
    if (common.getDeviceType() === 'MobileApp') {
      window.M.data.removeStorage('memberId')
    }
    props.registComplete()
    props.setInitialState()
  }, [])

  return (
    <div id="contents">
      <div className="content-header type2">
        {/* mobile 뒤로가기 버튼 */}
        <a
          onClick={(e) => {
            e.preventDefault()
            window.history.back()
          }}
          className="page-prev"
        >
          뒤로이동
        </a>
        <h2>회원가입</h2>
        <div className="breadcrumb">
          <span>Home</span>
          <em>회원가입</em>
        </div>
      </div>
      <div className="join-wrap">
        <ul className="steps">
          <li>
            <span className="num">1</span>약관동의
          </li>
          <li>
            <span className="num">2</span>본인인증
          </li>
          <li>
            <span className="num">3</span>회원정보 입력
          </li>
          <li className="on">
            <span className="num">4</span>가입완료
          </li>
        </ul>
        <div className="join-end">
          <i />
          <p className="txt1">
            전자문서지갑 회원가입이
            <br /> 완료되었습니다!
          </p>
        </div>
        <div className="btn-block center">
          <a className="btn-primary xl cursor" onClick={() => history.replace('/loginIntro')}>
            로그인 페이지로 이동
          </a>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {
  registComplete: regisActions.registComplete,
  setInitialState: certificateActions.setInitialState,
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisUserStep3)
